import RouterFrame from '../../../../components/share/RouterFrame.vue'
// Bundles: Internal/Gen
import IntgenPersonListing from '../../../../components/bundles/intgen/admin/person/Listing.vue'

export default function (service, name) {
  return {
    path: 'person',
    component: RouterFrame,
    meta: {
      title: 'menu.victimsDatabase',
      icon: 'users',
      menuLink: true,
      acl: {
        service: service,
        action: 'get_persons'
      }
    },
    children: [
      {
        path: '',
        component: IntgenPersonListing,
        name: `${service}_person_listing`,
        meta: {
          title: 'Lista poszkodowanych',
          acl: {
            service: service,
            action: 'get_persons'
          }
        }
      }
    ]
  }
}
